import styled from 'styled-components'
import { LookButton, buttonLook } from 'components/Buttons/look'
import { Link } from 'react-router-dom'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 10px;
  margin-left: 50px;
`

export const Header = styled.div`
  padding: 12px 20px;
  background-color: #FFFFFF;
  flex-direction: row;
  justify-content: center;
`

export const InfoContainer = styled.div`
  width: 580px;
  display: flex;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 0px;
`

export const Info = styled(InfoContainer)`
  margin: 0px;
  padding: 0px !important;
  border: 0px;
  box-shadow: none;
  width: 100%;
`

export const FilterContainer = styled.div`
  display: flex;
  min-width: 500px;
  flex-direction: row;
  justify-content: center;
  align-self: center;
  align-items: center;
  margin-top: 15px;
  gap: 10px;
`

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 10px;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin: 20px 0px 10px;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`

export const Column = styled(Container)`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px;
  margin-left: 0px;
`

export const TabRow = styled(Row)`
  margin-bottom: 10px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: 500;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin: 0px;
`

export const MoneyText = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`

export const LinkText = styled(LookButton).attrs(buttonLook({ variant: 'link' }))``
